import React from 'react';
import { DefaultFlexStrechedWrapper } from 'src/components/ui/odfjellPanel/OdfjellPanel.styles';
import { ReportOptionDescriptionText, ReportOptionIconWrapper, ReportOptionWrapper } from '../PageHeaderStowage.style';
import { OptionOpacityWrapper } from './reportPanel.style';

interface IncludeUnNoSelectorProps {
    includeUnNo: boolean;
    setIncludeUnNo: (includeUnNo: boolean) => void;
    disabled?: boolean;
}

const IncludeUnNoSelector: React.FC<IncludeUnNoSelectorProps> = ({ includeUnNo, setIncludeUnNo, disabled }) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIncludeUnNo(event.target.checked);
    };

    return (
        <ReportOptionWrapper onClick={() => !disabled && setIncludeUnNo(!includeUnNo)} disabled={disabled}>
            <OptionOpacityWrapper disabled={disabled}>
                <DefaultFlexStrechedWrapper noMargin>
                    <ReportOptionIconWrapper>
                        <input
                            type="checkbox"
                            checked={includeUnNo}
                            onChange={handleChange}
                            onClick={(e) => e.stopPropagation()}
                            aria-label="Include UN No."
                            disabled={disabled}
                            style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                        />
                    </ReportOptionIconWrapper>
                    <ReportOptionDescriptionText>Include UN No.</ReportOptionDescriptionText>
                </DefaultFlexStrechedWrapper>
            </OptionOpacityWrapper>
        </ReportOptionWrapper>
    );
};

export default IncludeUnNoSelector;
